var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"skill",staticClass:"global",staticStyle:{"color":"#00f2ea"}})
}
var staticRenderFns = []

export { render, staticRenderFns }